var render = function render(){var _vm=this,_c=_vm._self._c;return _c('appointment-new-space-coordination',{attrs:{"get-appointment-info":_vm.getAppointmentInfo,"get-contact-information":_vm.getContactInformation,"get-phone-providers":_vm.getPhoneProviders,"get-relationships":_vm.getRelationships,"navigate-to":_vm.navigateTo,"save-space-coordination":_vm.saveSpaceCoordination}})
}
var staticRenderFns = []

export { render, staticRenderFns }